'use client';

import React from 'react';
import { Worker, Viewer, SpecialZoomLevel } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';

// Import styles
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';

const SAMPLE_PDF_URL = 'https://tsoministries.com/wp-content/uploads/2026/03/Updated_Magazine-compressed.pdf';

export default function Magazine() {
  // Initialize the plugin for the toolbar/sidebar
  const defaultLayoutPluginInstance = defaultLayoutPlugin({
    sidebarTabs: (defaultTabs) => [], // Hide sidebar to look like a magazine
  });

  return (
    <div className="flex flex-col h-screen bg-gray-100">
      <header className="p-4 bg-gray-800 border-b shadow-sm h-20 flex items-center justify-center">
        <h1 className="text-xl font-bold opacity-0">BST Anniversary Magazine</h1>
      </header>

      <div className="flex-1 overflow-hidden">
        {/* The Worker component handles the background logic automatically */}
        <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
          <Viewer
            fileUrl={SAMPLE_PDF_URL}
            plugins={[defaultLayoutPluginInstance]}
            defaultScale={SpecialZoomLevel.PageWidth}
            // This ensures smooth scrolling on mobile
          />
        </Worker>
      </div>
    </div>
  );
}


// 'use client';

// import React, { useState, useRef, useCallback } from 'react';
// import { Maximize2, Minimize2, ExternalLink } from 'lucide-react';
// import { Button } from '../components/ui/button';

// const SAMPLE_PDF_URL = 'https://tsoministries.com/wp-content/uploads/2026/03/BST_ANNIVERSARY.pdf';

// export default function Magazine() {
//   const containerRef = useRef<HTMLDivElement>(null);
//   const [isFullscreen, setIsFullscreen] = useState(false);

//   // Fullscreen handler
//   const toggleFullscreen = useCallback(async () => {
//     if (!containerRef.current) return;
//     try {
//       if (!isFullscreen) {
//         if (containerRef.current.requestFullscreen) {
//           await containerRef.current.requestFullscreen();
//         }
//         setIsFullscreen(true);
//       } else {
//         if (document.fullscreenElement) {
//           await document.exitFullscreen();
//         }
//         setIsFullscreen(false);
//       }
//     } catch (error) {
//       console.error('Error toggling fullscreen:', error);
//     }
//   }, [isFullscreen]);

//   return (
//     <div
//       ref={containerRef}
//       className="flex flex-col h-screen bg-background text-foreground overflow-hidden"
//     >
//       {/* Header */}
//       <header className="border-b border-border bg-card px-4 py-3 sm:px-6 bg-gray-800">
//         <div className="flex items-center justify-between gap-4 opacity-0">
//           <div className="flex-1">
//             <h1 className="text-lg sm:text-xl font-semibold">Magazine Viewer</h1>
//             <p className="text-xs sm:text-sm text-muted-foreground">Native Browser View</p>
//           </div>
//           <div className="flex gap-2">
//              <Button variant="outline" size="sm" asChild className="hidden sm:flex">
//                 <a href={SAMPLE_PDF_URL} target="_blank" rel="noreferrer">
//                     <ExternalLink className="w-4 h-4 mr-2" /> Open Original
//                 </a>
//              </Button>
//              <Button variant="ghost" size="sm" onClick={toggleFullscreen}>
//                 {isFullscreen ? <Minimize2 className="w-4 h-4" /> : <Maximize2 className="w-4 h-4" />}
//              </Button>
//           </div>
//         </div>
//       </header>

//       {/* Main Content: The Browser's Native PDF Engine */}
//       <div className="flex-1 bg-muted/30 p-0 sm:p-4">
//         <iframe
//           src={`${SAMPLE_PDF_URL}#toolbar=1&navpanes=0&scrollbar=1`}
//           className="w-full h-full border-none shadow-lg rounded-md"
//           title="PDF Magazine"
//         />
//       </div>

//       {/* Footer Info */}
//       <footer className="border-t border-border bg-card px-4 py-2 text-center">
//         <p className="text-xs text-muted-foreground">
//           T.S.S Ministries - 2026 Anniversary Magazine.
//         </p>
//       </footer>
//     </div>
//   );
// }